import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { BulkMailerService } from '../../core/service/bulkMailer/bulk-mailer.service';
import { MaterialModuleModule } from '../material-module.module';
import { CommonModule, Location } from '@angular/common';
import { LoaderService } from '../../core/service/loader.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-unsubscribe-mail',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModuleModule
  ],

  templateUrl: './unsubscribe-mail.component.html',
  styleUrl: './unsubscribe-mail.component.scss'
})
export class UnsubscribeMailComponent implements OnInit {
  private _bulkMailerService = inject(BulkMailerService);
  private _destroyRef = inject(DestroyRef);
  public _loader = inject(LoaderService);
  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute);
  private _location = inject(Location);

  logsDetails: any;

  ngOnInit(): void {
    this._route.queryParams
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (res) => {
          let params = res;
          this.getUnsubscribeMailLog(
            { 
              campaignId: params['campaignId'],  
              recipientId: params['recipientId'],
              token: params['token'] 
            }
          );
        },
        error: (err) => {

        }
      })
  }

  getUnsubscribeMailLog(payload: any): void {
    this._loader.show();
    this._bulkMailerService
      .getUnsubscribeMailLog(payload)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (response) => {
          this._loader.hide();
          this.logsDetails = response;
        },
        error: (err) => {
          this._loader.hide();
        }
      })
  }

  return() {
    this._location.back();
  }

}
